import {
    OBTENER_LLAVES,
    GET_CONFIG_FORM87,
    GET_FECHAS_IR,
    GET_COMBO_TIPO_FECHA_IR,
    GET_BUSQUEDA_CASOS_IR,
    GET_EXCEL_IR,
    CLEAN_CASOS_IR,
    SET_QUERY_STATE_IR
} from '../types';


export default function areaBusquedaCasosIngresoRecuperoReducer(state = {}, action) {
    switch (action.type) {
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case GET_CONFIG_FORM87:
            return { ...state, cfg_form87:action.payload }
        case GET_FECHAS_IR:
            return { ...state, fechas:action.payload }
        case GET_COMBO_TIPO_FECHA_IR:
            return { ...state, comboTipoFecha:action.payload }
        case GET_BUSQUEDA_CASOS_IR:
            return { ...state, casosIngresoRecuperosCuota:action.payload }
        case GET_EXCEL_IR:
            return { ...state, excel:action.payload }
        case CLEAN_CASOS_IR:
            return { ...state, casosIngresoRecuperosCuota:{} }
        case SET_QUERY_STATE_IR:
            return { ...state, myQueryStateGlobal:action.payload }
        default:
            return state
    }
}